(function() {
    'use strict';
    /*
     * Copyright (c) 2014-2017 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .constant('AUTH_EVENTS', {
            loginSuccess: 'auth-login-success',
            logout: 'auth-logout',
            notAuthorized: 'auth-not-authorized',
            forbidden: 'auth-forbidden'
        });
})();